var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.877,
    height: 16.804,
    viewBox: "0 0 23.877 16.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30549",
    "data-name": "Group 30549",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M22.3,2.835H20.062a3.548,3.548,0,0,1-7.031,0H6.243A3.408,3.408,0,0,0,2.835,6.243v8.988a3.408,3.408,0,0,0,3.408,3.408h6.849a3.549,3.549,0,0,1,6.908,0h2.3a3.408,3.408,0,0,0,3.408-3.408V6.243A3.408,3.408,0,0,0,22.3,2.835Z",
    transform: "translate(-2.835 -2.835)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fc8a06",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y2: 1.94,
    transform: "translate(13.711 3.068)",
    fill: "none",
    stroke: "#fc8a06",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y2: 3.032,
    transform: "translate(13.711 6.386)",
    fill: "none",
    stroke: "#fc8a06",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_9",
    "data-name": "Line 9",
    y2: 1.94,
    transform: "translate(13.711 11.072)",
    fill: "none",
    stroke: "#fc8a06",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgesIcon);
export default __webpack_public_path__ + "static/media/BadgesIcon.9360bb53a2f75c14e7194975ae156acd.svg";
export { ForwardRef as ReactComponent };